export default __webpack_public_path__ + "static/media/img_step_lucia09_m.17dda509.jpg";